import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useGetTournamentsList(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async ({
      limit = 5,
      offset = 0,
      userId,
    }: {
      limit?: number;
      offset?: number;
      userId: string;
    }) => {
      const response = await TournamentRestClient.get(
        `/tournament/get-circlechess-tournaments?limit=${limit}&offset=${offset}&userId=${userId}`,
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return mutation;
}
